<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Registers</a>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/user_services">Service Registers</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page" v-if="status">New Service Register</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update Service Register</li>
                </ol>
                <h4 class="main-title mb-0">Service Register</h4>
            </div>
            <router-link to="/user_services" type="submit" class="btn btn-primary" style="float: right;"><i class="ri-list-check"></i> SERVICE REGISTERS</router-link>
        </div>
        <div class="row">
            <div class="col-12" v-can="'service_registers.create'">
                <form @submit.prevent="submitForm">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Service Register</h6>
                            <h6 class="card-title" v-else>Update Service Register</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2 mb-5">
                                <!-- <div class="col-md-4">
                                    <label class="form-label">Service Number</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Enter Service Number" class="form-control" :class="{'is-invalid':errors.service_no}" v-model="user_service.service_no" ref="service_no"/>
                                    <span v-if="errors.service_no" class="invalid-feedback">{{ errors.service_no[0] }}</span>
                                </div> -->
                                <div class="col-md-4">
                                    <label class="form-label">Service Date</label><span class="text-danger"> *</span>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter Service Date"
                                        :class="{'is-invalid': errors?.service_date}"
                                        :value="convertDateFormat(user_service.service_date)"
                                        v-model="user_service.service_date"
                                        ref="service_date"
                                    />
                                    <span v-if="errors?.service_date" class="invalid-feedback">{{ errors?.service_date[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Asset</label><span class="text-danger"> *</span>
                                    <!-- <search
                                        :class="{ 'is-invalid': errors?.asset_id }"
                                        :customClass="{ 'is-invalid': errors?.asset_id }"
                                        :initialize="user_service.asset_id"
                                        id="asset_id"
                                        label="asset_name"
                                        label2="asset_code"
                                        placeholder="Select Asset"
                                        :data="assets"
                                        @input=" asset => user_service.asset_id = asset"
                                    >
                                    </search> -->
                                    <AssetSearch :disabled="!status" :initialize="user_service.asset_name" :asset_id="user_service.asset_id" @selectAsset="selectAsset($event)" ref="asset_id"></AssetSearch>
                                    <span v-if="errors?.asset_id" class="invalid-feedback">{{ errors?.asset_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Service</label><span class="text-danger"> *</span>
                                    <search
                                        :disabled="!status"
                                        :class="{ 'is-invalid': errors?.service_id }"
                                        :customClass="{ 'is-invalid': errors?.service_id }"
                                        :initialize="user_service.service_id"
                                        id="service_id"
                                        label="service_name"
                                        label2="service_code"
                                        placeholder="Select Service"
                                        :data="services"
                                        @input=" service => user_service.service_id = service"
                                        @selectsearch="getFrequency(user_service.service_id)"
                                        disabled="!status"
                                    >
                                    </search>
                                    <span v-if="errors?.service_id" class="invalid-feedback">{{ errors?.service_id[0] }}</span>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Next Service Date</label><span class="text-danger"> *</span>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter Next Service Date"
                                        :class="{'is-invalid': errors?.next_service_date}"
                                        :value="convertDateFormat(user_service.next_service_date)"
                                        v-model="user_service.next_service_date" disabled="disabled"
                                    />
                                    <span v-if="errors?.next_service_date" class="invalid-feedback">{{ errors?.next_service_date[0] }}</span>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label">Service Cost</label>
                                    <input type="number" placeholder="Enter Service Cost" min="0" oninput="validity.valid||(value='');" class="form-control" :class="{'is-invalid':errors?.service_cost}" v-model="user_service.service_cost" />
                                    <span v-if="errors?.service_cost" class="invalid-feedback">{{ errors?.service_cost[0] }}</span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Note</label>
                                    <textarea type="text" placeholder="Enter Note" class="form-control" :class="{'is-invalid': errors?.note}" v-model="user_service.note"></textarea>
                                    <span v-if="errors?.note" class="invalid-feedback">{{ errors?.note[0] }}</span>
                                </div>
                            </div>

                            <div class="row g-2">
                                <div class="">
                                    <table class="table table-responsive table-responsive-sm table-sm text-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Spare <span class="text-danger"> *</span></th>
                                                <th>Quantity <span class="text-danger"> *</span></th>
                                                <th>Spare Cost <span class="text-danger"> *</span></th>
                                                <th>Total <span class="text-danger"> *</span></th>
                                                <th class="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <search
                                                        :class="{ 'is-invalid': errors.spare_id }"
                                                        :customClass="{ 'is-invalid': errors.spare_id }"
                                                        aria-describedby="basic-addon2"
                                                        aria-label="Select Spare"
                                                        :initialize="user_spare.spare_id"
                                                        id="spare_id"
                                                        label="spare_name"
                                                        label2="spare_code"
                                                        placeholder="Select Spare"
                                                        :data="spares"
                                                        @input=" spare1 => user_spare.spare_id = spare1"
                                                        @selectsearch="getValue(user_spare.spare_id)"
                                                    >
                                                    </search>
                                                    <span v-if="errors.spare_id" class="invalid-feedback">{{ errors.spare_id[0] }}</span>
                                                </td>
                                                <td>
                                                    <input type="number" step="any" class="form-control" placeholder="Enter Quantity" min="0" :class="{ 'is-invalid': errors.quantity }" v-model="user_spare.quantity" @input="calculateTotal"  @keypress="preventSigns"/>
                                                    <span v-if="errors.quantity" class="invalid-feedback">{{ errors.quantity[0] }}</span>
                                                </td>
                                                <td>
                                                    <input type="number" step="any"  class="form-control" placeholder="Enter Spare Cost" min="0" :class="{ 'is-invalid': errors.spare_cost }" v-model="user_spare.spare_cost" @input="calculateTotal" @keypress="preventSigns"/>
                                                    <span v-if="errors.spare_cost" class="invalid-feedback">{{ errors.spare_cost[0] }}</span>
                                                </td>
                                                <td>
                                                    <input type="number" step="any"  class="form-control" min="0" :class="{ 'is-invalid': errors.spare_cost }"   :value="user_spare.total" disabled/>
                                                    <span v-if="errors.total" class="invalid-feedback">{{ errors.total[0] }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <button v-if="user_spare.status" class="btn btn-outline-success mx-1" @click.prevent="addRow()"><i class="ri-add-line fs-18 lh-1"></i></button>
                                                    <button v-else class="btn btn-outline-success mx-1" @click.prevent="updateRow(user_spare)"><i class="ri-save-line fs-18 lh-1"></i></button>
                                                    <button class="btn btn-outline-danger mx-1" @click.prevent="discardNewRow()"><i class="ri-close-line fs-18 lh-1"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="spare, index in user_service.user_spares" :key="index">
                                                <td>{{ spare?.spare?.spare_name }}</td>
                                                <td>{{ spare?.quantity }}</td>
                                                <td>{{ spare?.spare_cost }}</td>
                                                <td>{{ spare?.total }}</td>
                                                <td class="text-center">
                                                    <button type="button" class="btn btn-outline-primary mx-2" @click.prevent="editSpare(spare,index)"><i class="ri-pencil-line fs-18 lh-1"></i></button>
                                                    <button type="button" class="btn btn-outline-danger" @click.prevent="deleteSpare(spare,index)"><i class="ri-delete-bin-line fs-18 lh-1"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="text-center">
                                        <span v-if="errors.user_spares" class="invalid-feedback d-block">{{ errors.user_spares[0] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <router-link type="button" to="/user_services" class="btn btn-danger me-2"><i class="ri-arrow-left-line fs-18 lh-1"></i> Back</router-link>
                            <button type="submit" class="btn btn-primary">
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Search from "@/components/Search.vue";
import AssetSearch from "@/components/AssetSearch.vue";
    import moment from "moment";
    export default {
        name: "Assets.Create",
        components: { Search,AssetSearch },
        data() {
            return {
                user_service: {
                    user_service_id: "",
                    service_no: "",
                    service_date: "",
                    asset_id: "",
                    asset_code:"",
                    asset_name:"",
                    service_cost: "",
                    next_service_date: "",
                    service_id: "",
                    note: "",
                    user_spares: [],
                    deleted_user_spares: [],
                    status: true,
                },
                user_spare: {
                    user_spare_id: "",
                    spare_id: "",
                    spare: {
                        spare_name: "",
                    },
                    spare_cost: "",
                    quantity:"",
                    total:"",
                    status: true,
                },
                deleted_spares: [],
                assets: [],
                services: [],
                spares: [],
                errors: [],
                status: true,
            };
        },

        watch:{
            'user_service.asset_id': function(){
                this.getSpares();
                this.getServices();
            },
            'user_service.service_date': function (newDate) {
                if (!newDate) {
                    return;
                }
                if (this.user_service.next_service_date && moment(this.user_service.next_service_date).isBefore(moment(newDate), 'day')) {
                    if (this.user_service.service_id) {
                        this.getFrequency(this.user_service.service_id);
                    } else {
                        this.user_service.next_service_date = moment(newDate).format('YYYY-MM-DD');
                    }
                }
            },
            'user_service.service_id': function (id) {
                if (id && this.user_service.service_date) {
                    this.getFrequency(id);
                }
            },
            // 'user_spare.quantity': 'calculateTotal',
            // 'user_spare.spare_cost': 'calculateTotal',
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // vm.getAssets();
                if (to.name == "UserServices.Create") {
                    if(vm.$store.getters.asset_id){
                        vm.user_service.asset_id = vm.$store.getters.asset_id
                        vm.getAsset();
                    }
                    if (vm.$store.getters.dashboard_asset_id && vm.$store.getters.dashboard_service_id) {
                        vm.user_service.asset_id = vm.$store.getters.dashboard_asset_id
                        vm.user_service.service_id = vm.$store.getters.dashboard_service_id
                        vm.getAsset();

                         // 💡 Call after small delay to ensure services are loaded
                // vm.getServices(); // fetch services before calculating frequency

                setTimeout(() => {
                    vm.getFrequency(vm.user_service.service_id);
                }, 500); // small delay to allow service list to populate
                    }
                    vm.$refs.service_date.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getUserService", data: { user_service_id: to.params.user_service_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.user_service = response.data.data;
                            vm.user_service.asset_id = vm.user_service.asset.asset_id;
                            vm.user_service.asset_code = vm.user_service.asset.asset_code;
                            vm.user_service.asset_name = vm.user_service.asset.asset_name;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
        mounted() {
            this.user_service.service_date = moment().format("yyyy-MM-DD");
            this.user_service.next_service_date = moment().format("yyyy-MM-DD");
        },
    methods: {
        preventSigns(event) {
                const char = event.key;

                // Block - and + and e (which triggers scientific notation like 1e5)
                if (char === '-' || char === '+' || char.toLowerCase() === 'e') {
                event.preventDefault();
                }
            },
            calculateTotal() {
                const qty = parseFloat(this.user_spare.quantity) || 0;
                const cost = parseFloat(this.user_spare.spare_cost) || 0;
                this.user_spare.total = qty * cost;
            },
            /**
             * Matches backend: next = service_date + max(0, frequency) days (equal when frequency is 0).
             */
            getFrequency(service_id) {
                const vm = this;
                const service = vm.services?.find((ele) => ele.service_id === service_id);
                if (service === undefined || service === null || service.frequency === undefined || service.frequency === null) {
                    return;
                }
                if (!vm.user_service.service_date) {
                    return;
                }
                const days = Math.max(0, Number(service.frequency) || 0);
                const frequency_date = moment(vm.user_service.service_date).startOf('day').add(days, 'days').format('YYYY-MM-DD');
                vm.user_service.next_service_date = frequency_date;
            },
            expectedNextServiceDate() {
                const service = this.services?.find((ele) => ele.service_id === this.user_service.service_id);
                if (!service || !this.user_service.service_date) {
                    return null;
                }
                const days = Math.max(0, Number(service.frequency) || 0);
                return moment(this.user_service.service_date).startOf('day').add(days, 'days').format('YYYY-MM-DD');
            },
            convertDateFormat(date) {
                let vm = this;
                return moment(date).format("yyyy-MM-DD");
            },
            submitForm() {
                let vm = this;
                vm.errors = {};

                if (!vm.user_service.service_date || !vm.user_service.next_service_date) {
                    vm.$store.dispatch('error', 'Service Date and Next Service Date are required.');
                    return;
                }

                const svc = moment(vm.user_service.service_date).startOf('day');
                const nxt = moment(vm.user_service.next_service_date).startOf('day');
                if (nxt.isBefore(svc, 'day')) {
                    vm.errors.next_service_date = ['Next Service Date must be on or after Service Date.'];
                    vm.$store.dispatch('error', 'Next Service Date must be on or after Service Date.');
                    return;
                }

                const expected = vm.expectedNextServiceDate();
                if (expected && vm.user_service.service_id) {
                    if (!nxt.isSame(moment(expected), 'day')) {
                        vm.errors.next_service_date = ['Next Service Date must match Service Date plus the service frequency (in days).'];
                        vm.$store.dispatch('error', 'Next Service Date must match the selected service frequency.');
                        return;
                    }
                }

                if (vm.status) {
                    vm.addUserService();
                } else {
                    vm.updateUserService();
                }
            },
            getValue(value) {
                let vm = this;
                let spare = vm.spares?.filter(function (ele) {
                    return ele.spare_id == value;
                });
                if (spare.length) {
                    vm.user_spare.spare.spare_name = spare[0].spare_name;
                }
            },
            getAssets() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAssets" })
                    .then((response) => {
                        loader.hide();
                        vm.assets = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getServices() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAssetsServices", data: vm.user_service })
                    .then((response) => {
                        loader.hide();
                        vm.services = response.data;

                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getSpares() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAssetServiceSpares", data: vm.user_service })
                    .then((response) => {
                        loader.hide();
                        vm.spares = response.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            addUserService() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addUserService", data: vm.user_service })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/user_services");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            updateUserService() {
                let vm = this;
                vm.user_service.deleted_user_spares = vm.deleted_spares;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateUserService", data: vm.user_service })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/user_services");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getAsset() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAsset", data:{asset_id: vm.user_service.asset_id  }})
                    .then((response) => {
                        loader.hide();
                        vm.asset_data = response.data.data;
                        vm.user_service.asset_name = vm.asset_data.asset_name
                        vm.user_service.asset_code = vm.asset_data.asset_code
                    })
                    .catch(function (error) {
                        console.log("errror--",error)
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
        },
            getService() {
                alert("Dd")
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getService", data:{service_id: vm.user_service.service_id  }})
                    .then((response) => {
                        loader.hide();
                        console.log("rr",response)
                        // vm.asset_data = response.data.data;
                        // vm.user_service.asset_name = vm.asset_data.asset_name
                        // vm.user_service.asset_code = vm.asset_data.asset_code
                    })
                    .catch(function (error) {
                        console.log("errror--",error)
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            addRow() {
                let vm = this;
                vm.errors = {};
                if (vm.user_spare.spare_id == "" || vm.user_spare.spare_cost == "" || vm.user_spare.quantity == "") {
                    if (vm.user_spare.spare_id == "") {
                        vm.errors.spare_id = ["Spare field cannot be empty"];
                    }
                    if (vm.user_spare.spare_cost === null || vm.user_spare.spare_cost === undefined || vm.user_spare.spare_cost === "") {
                        vm.errors.spare_cost = ["Spare Cost cannot be empty"];
                    }
                    if (vm.user_spare.quantity === null || vm.user_spare.quantity === undefined || vm.user_spare.quantity === "") {
                        vm.errors.quantity = ["Quantity cannot be empty"];
                    }
                    // if (Object.keys(vm.errors).length > 0) {
                    //     return;
                    // }
                } else {

                    vm.user_service.user_spares.push({
                        user_spare_id: "",
                        spare_id: vm.user_spare.spare_id,
                        spare: {
                            spare_name: vm.user_spare.spare.spare_name,
                        },
                        spare_cost: vm.user_spare.spare_cost,
                        quantity : vm.user_spare.quantity,
                        total : vm.user_spare.total
                    });
                    vm.discardNewRow();
                }
            },
            discardNewRow() {
                let vm = this;
                vm.user_spare.user_spare_id = "";
                vm.user_spare.spare_id = "";
                vm.user_spare.spare_cost = "";
                vm.user_spare.quantity= "";
                vm.user_spare.total= "";
                vm.user_spare.spare.spare_name = "";
                vm.user_spare.status = true;
                vm.errors = [];
            },
            editSpare(spare, key) {
                let vm = this;
                vm.user_spare.user_spare_id = spare.user_spare_id;
                vm.user_spare.spare_id = spare.spare_id;
                vm.user_spare.spare.spare_name = spare.spare.spare_name;
                vm.user_spare.spare_cost = spare.spare_cost;
                vm.user_spare.quantity = spare.quantity;
                vm.user_spare.total = spare.total;
                vm.user_spare.status = false;
                vm.user_spare.key = key;
                vm.errors = [];
            },
            updateRow(spare) {
                let vm = this;
                vm.errors = {};
                if (vm.user_spare.spare_id == "" || vm.user_spare.spare_cost == "" || vm.user_spare.quantity == "") {
                    if (vm.user_spare.spare_id == "") {
                        vm.errors.spare_id = ["Spare field cannot be empty"];
                    }
                    if (vm.user_spare.spare_cost === null || vm.user_spare.spare_cost === undefined || vm.user_spare.spare_cost === "") {
                        vm.errors.spare_cost = ["Spare Cost cannot be empty"];
                    }
                    if (vm.user_spare.quantity === null || vm.user_spare.quantity === undefined || vm.user_spare.quantity === "") {
                        vm.errors.quantity = ["Quantity cannot be empty"];
                    }
                    // if (Object.keys(vm.errors).length > 0) {
                    //     return;
                    // }
                } else {
                    let spare_data = vm.user_service.user_spares.filter(function (element) {
                        return element.key == spare.key;
                    });
                    vm.user_service.user_spares[spare_data.key] = spare_data;
                    vm.user_service.user_spares.splice(vm.user_spare.key, 1);
                    vm.user_service.user_spares.push({
                        user_spare_id: vm.user_spare.user_spare_id,
                        spare_id: vm.user_spare.spare_id,
                        spare: {
                            spare_name: vm.user_spare.spare.spare_name,
                        },
                        spare_cost: vm.user_spare.spare_cost,
                        quantity: vm.user_spare.quantity,
                        total: vm.user_spare.total,
                    });
                    vm.discardNewRow();
                }
            },
            deleteSpare(spare, key) {
                let vm = this;
                // let sp = vm.user_service.user_spares.filter(function (element) {
                //     return element.spare_id == spare.user_spare_id;
                // });
                if (confirm("Are you sure you want to delete")) {
                    vm.deleted_spares.push(spare?.user_spare_id);
                    vm.user_service.user_spares.splice(key, 1);
                    vm.discardNewRow();
                }
        },
             selectAsset(e) {
                const asset = e.target.value;
                this.user_service.asset_name = asset.asset_name;
                 this.user_service.asset_id = asset.asset_id;
                this.user_service.asset_code = asset.asset_code;

            },
        },
    };
</script>
<style scoped>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
